module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"The Hummingbird Art Gallery","short_name":"Hummingbird Gallery","start_url":"/","background_color":"#fedbd0","theme_color":"#fff","display":"minimal-ui","icon":"src/images/site-logo.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
